import { BuzzContentReferenceResponse } from "../../../../../common/api/catalogue-api/buzz/BuzzContentReferenceResponse";
import { EpisodeDetails, EpisodeVersionDetails } from "../../../TvSeriesDetails";

export interface EpisodeListingItem {
    id: string;
    title: string;
    episodeNumber: number;
    orphaned: boolean;
    isModified?: boolean;
    buzzId?: string;
    merged?: boolean;
    orphanedDetails: string[];
    buzz?: BuzzContentReferenceResponse;
}

export const mapToEpisodeListingItem = (episode: EpisodeDetails, isModified?: boolean): EpisodeListingItem => {
    return {
        id: episode.id,
        title: episode.title,
        orphaned: episodeOrphaned(episode),
        isModified,
        episodeNumber: episode.number,
        buzzId: episode.buzz?.id,
        merged: !!episode.mergedTargetId,
        buzz: episode.buzz,
        orphanedDetails: getEpisodeOrphanedDetails(episode)
    };
};

const episodeOrphaned = (episode: EpisodeDetails) => {
    return (
        !episode.buzz ||
        episode.versions.some((version: EpisodeVersionDetails) => !version.buzzVersion?.id && !version.mergedTargetId)
    );
};

const getEpisodeOrphanedDetails = (episode?: EpisodeDetails): string[] => {
    if (!episode) {
        return ["Episode is orphaned"];
    }

    const messages: string[] = [];
    const orphanedVersionsCount = getEpisodeVersionsOrphanedCount(episode.versions);
    const orphaned = !episode.buzz?.id || orphanedVersionsCount > 0;

    if (orphaned) {
        messages.push("Episode is orphaned");
    }

    if (orphanedVersionsCount > 0) {
        messages.push(`Orphaned versions count: ${orphanedVersionsCount}`);
    }

    return messages;
};

const getEpisodeVersionsOrphanedCount = (episodeVersions: EpisodeVersionDetails[]): number => {
    const orphanedVersions = episodeVersions.filter(
        (version: EpisodeVersionDetails) => !version.buzzVersion && !version.mergedTargetId
    );

    return orphanedVersions.length;
};
